import { createSlice } from '@reduxjs/toolkit';
import { getContentThunk } from "../../../../shared/model";
var initialState = {
  isFiltersEnabled: false,
  isFiltersVisible: false,
  sortType: 'none'
};
export var filtersSlice = createSlice({
  name: 'filters',
  initialState: initialState,
  reducers: {
    setIsFiltersVisible: function setIsFiltersVisible(state, _ref) {
      var payload = _ref.payload;
      state.isFiltersVisible = payload;
    },
    setSortType: function setSortType(state, _ref2) {
      var payload = _ref2.payload;
      state.sortType = payload;
    },
    setSearch: function setSearch(state, _ref3) {
      var payload = _ref3.payload;
      state.search = payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getContentThunk.fulfilled, function (state, _ref4) {
      var _payload$data$Feature, _payload$data;
      var payload = _ref4.payload;
      state.isFiltersEnabled = (_payload$data$Feature = (_payload$data = payload.data) === null || _payload$data === void 0 || (_payload$data = _payload$data.FeatureTogglesWeb) === null || _payload$data === void 0 || (_payload$data = _payload$data.content) === null || _payload$data === void 0 ? void 0 : _payload$data.FeatureTogglesWebSearchEnabled) !== null && _payload$data$Feature !== void 0 ? _payload$data$Feature : false;
    });
  }
});
var _filtersSlice$actions = filtersSlice.actions,
  setSortType = _filtersSlice$actions.setSortType,
  setSearch = _filtersSlice$actions.setSearch,
  setIsFiltersVisible = _filtersSlice$actions.setIsFiltersVisible;
export { setSortType, setSearch, setIsFiltersVisible };